export default "__VITE_ASSET__636eec95__"